import { render, staticRenderFns } from "./CountrySwitcher.vue?vue&type=template&id=b9c635f0&lang=pug"
import script from "./CountrySwitcher.vue?vue&type=script&lang=js"
export * from "./CountrySwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports